/* eslint-disable react/forbid-elements */
/* eslint-disable max-lines */
import * as React from 'react';

export const CommunicationPaymentIllustration: React.FC = () => {
  return (
    <svg viewBox="0 0 340 216" height="100%" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="340" height="216" fill="white" />
      <path
        d="M100.318 69.0582L82.609 76.8048L88.7206 93.7738L53.4811 98.3145C53.4811 98.3145 45.1623 74.0401 58.3802 61.015C70.3329 49.2362 97.679 44.8933 107.695 47.8274C114.534 49.8329 137.055 53.971 141.986 64.7506C144.604 70.474 149.886 84.3854 149.886 84.3854L163.79 77.7969V108.427C163.79 108.427 152.47 116.021 143.286 116.781L132.128 108.261L131.952 105.779L90.5095 98.6711L89.0756 95.1862L100.462 69.0793"
        fill="#006CFD"
      />
      <path
        d="M100.318 69.0582L82.609 76.8048L88.7206 93.7738L53.4811 98.3145C53.4811 98.3145 45.1623 74.0401 58.3802 61.015C70.3329 49.2362 97.679 44.8933 107.695 47.8274C114.534 49.8329 137.055 53.971 141.986 64.7506C144.604 70.474 149.886 84.3854 149.886 84.3854L163.79 77.7969V108.427C163.79 108.427 152.47 116.021 143.286 116.781L132.128 108.261L131.952 105.779L90.5095 98.6711L89.0756 95.1862L100.462 69.0793"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M78.0575 203.889L72.6452 194.596L74.4481 189.403L46.4589 176.042L43.6754 181.232L32.9598 201.1L54.6371 211.35C58.2148 213.041 62.1158 213.935 66.0731 213.97L88.2599 214.164H90.1929C90.214 209.129 88.5341 205.574 84.4151 202.707L73.7206 195.988"
        fill="#006CFD"
      />
      <path
        d="M78.0575 203.889L72.6452 194.596L74.4481 189.403L46.4589 176.042L43.6754 181.232L32.9598 201.1L54.6371 211.35C58.2148 213.041 62.1158 213.935 66.0731 213.97L88.2599 214.164H90.1929C90.214 209.129 88.5341 205.574 84.4151 202.707L73.7206 195.988"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.6238 197.781L55.0904 206.986C58.3729 208.54 61.9506 209.366 65.5776 209.412L88.165 209.687"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.3509 188.664C47.8326 188.474 44.8594 189.72 44.6415 192.584C44.3392 196.531 48.8167 198.519 51.7583 196.093C54.6964 193.668 52.7529 189.099 49.3509 188.664Z"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.2194 194.558L72.3886 193.81"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66.2948 201.707L73.2956 196.411"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.6823 204.091L75.8436 197.93"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M109.962 192.849L105.354 214.807L165.501 214.718C165.494 210.058 163.203 205.701 159.372 203.07L143.11 191.892L142.833 187.062L109.955 187.114L109.962 192.849Z"
        fill="#006CFD"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M109.987 208.528L164.025 208.44"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M133.119 192.372L142.084 190.313"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M136.83 197.731L144.313 193.148"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M143.114 199.79L147.208 194.713"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M118.298 43.6078C118.298 43.6078 122.105 47.0715 127.939 45.3097C131.527 44.2257 133.513 41.3234 134.142 39.5544C134.859 37.5313 134.922 36.0201 134.968 34.8196C135.2 28.5242 132.286 24.6968 126.118 23.9482C116.696 22.8043 115.476 30.2755 115.476 30.2755C115.476 30.2755 112.728 30.2048 112.127 31.9738C111.319 34.35 113.649 35.893 113.649 35.893L108.497 48.3885C108.497 48.3885 112.194 53.7342 120.34 55.1748C127.113 56.3717 131.973 54.0237 131.973 54.0237C131.973 54.0237 133.01 44.7341 133.769 40.3983"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M126.505 32.2842C126.505 32.2842 125.943 33.8024 126.009 34.1025C126.076 34.4027 127.362 36.3835 127.152 37.0367C126.941 37.6899 124.751 36.8531 124.751 36.8531"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M126.406 40.7337C126.016 41.1079 125.376 41.4186 124.368 41.1644C123.359 40.9102 122.93 40.3276 122.751 39.8086"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M112.267 185.928L124.217 150.62L121.405 144.971"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M144.86 127.345C149.542 133.121 151.562 140.755 150.164 148.272L142.488 185.928"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M130.743 79.8516L132.127 108.26"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.7441 99.2354C55.7441 99.2354 57.0902 113.899 63.2475 114.337C65.9185 114.527 65.9255 113.352 65.9255 113.352"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.5005 106.008C63.5005 106.008 64.4881 114.27 68.3891 115.026C70.8422 115.499 71.7489 113.878 71.7489 113.878"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128.887 24.686C128.887 24.686 125.977 31.6347 115.627 29.7986C115.627 29.7986 118.242 22.0979 128.887 24.686Z"
        fill="#031D40"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128.88 24.6826C128.88 24.6826 134.359 26.8682 135.111 34.8125C135.111 34.809 128.304 30.6779 128.88 24.6826Z"
        fill="#031D40"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.3909 105.655C69.3909 105.655 69.3944 113.547 73.928 114.673C76.353 115.273 77.2879 113.879 77.2879 113.879"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M88.7203 93.7734C88.7203 93.7734 88.7203 98.3635 93.992 102.247C98.5608 105.616 92.9377 112.84 83.4486 104.719"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M164.472 108.218C164.472 108.218 175.103 102.873 177.619 101.655C182.388 99.3418 183.372 94.5893 180.086 92.2378C176.607 89.7451 169.923 91.9695 169.399 94.9212C168.879 97.8553 171.701 98.5721 174.825 97.5517"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M170.383 93.2688C170.383 93.2688 167.094 91.9094 169.069 88.9824C171.487 85.3951 178.442 84.0887 181.071 86.1154C184.36 88.6505 182.666 91.7435 181.545 93.9008"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M170.383 87.549C170.383 87.549 167.094 86.1897 169.069 83.2626C171.487 79.6753 178.442 78.3689 181.071 80.3956C183.696 82.4223 183.144 84.8021 182.248 86.7758"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M170.383 81.8498C170.383 81.8498 167.094 80.4905 169.069 77.5634C171.487 73.9761 178.442 72.6697 181.071 74.6964C183.654 76.6913 183.162 79.0252 182.29 80.9813"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M164.13 77.4542C164.13 77.4542 166.559 75.777 169.163 71.8119C171.767 67.8468 174.639 64.6973 177.355 66.032C179.214 66.9429 180.139 69.8523 178.399 72.8253"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.1735 144.265L47.2498 175.689"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.8292 150.267L74.2198 188.721"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M82.7463 76.8262L88.7209 93.7741L53.5833 98.3147"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 214.806H182.993L182.943 190.832H221.233L221.279 168.422H240.683H317.161"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M264.499 152.357V61.1843C264.499 58.861 266.376 56.9756 268.689 56.9756C271.001 56.9756 272.878 58.861 272.878 61.1843V152.357"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M307.773 90.6491H272.878V64.7012H307.773L301.022 77.7546L307.773 90.6491Z"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M239.139 168.045C245.504 158.579 256.283 152.357 268.506 152.357C280.663 152.357 291.392 158.512 297.767 167.889"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M297.543 65.0537L272.878 89.833"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M306.413 65.0537L281.175 90.405"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M301.581 78.8164L290.046 90.4045"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M304.639 84.6572L298.913 90.4054"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M288.676 65.0537L272.878 80.9247"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M279.805 65.0537L272.878 72.0129"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M239.14 48.5752V56.6043"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M239.14 67.6201V75.6492"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M252.614 62.1123H244.625"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M233.657 62.1123H225.665"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M259.699 24.5098V28.782"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M259.699 34.6426V38.9113"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M266.868 31.7129H262.616"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M256.782 31.7129H252.53"
        stroke="#006CFD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M120.909 25.8375C124.164 25.8375 126.803 23.1865 126.803 19.9163C126.803 16.6461 124.164 13.9951 120.909 13.9951C117.654 13.9951 115.016 16.6461 115.016 19.9163C115.016 23.1865 117.654 25.8375 120.909 25.8375Z"
        fill="#031D40"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M110.208 21.342C114.266 21.342 117.556 18.0366 117.556 13.9591C117.556 9.88162 114.266 6.57617 110.208 6.57617C106.149 6.57617 102.859 9.88162 102.859 13.9591C102.859 18.0366 106.149 21.342 110.208 21.342Z"
        fill="#031D40"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.616 21.5613C99.2662 21.5613 103.847 16.9596 103.847 11.2831C103.847 5.60659 99.2662 1.00488 93.616 1.00488C87.9658 1.00488 83.3854 5.60659 83.3854 11.2831C83.3854 16.9596 87.9658 21.5613 93.616 21.5613Z"
        fill="#031D40"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M74.2156 33.6614C81.7097 33.6614 87.7849 27.558 87.7849 20.029C87.7849 12.4999 81.7097 6.39648 74.2156 6.39648C66.7214 6.39648 60.6462 12.4999 60.6462 20.029C60.6462 27.558 66.7214 33.6614 74.2156 33.6614Z"
        fill="#031D40"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.8255 114.605L62.7133 141.44C62.7133 141.44 83.4486 154.857 111.916 147.795C142.783 140.137 146.709 123.432 146.709 123.432L132.3 108.25"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M116.485 174.276H144.249"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M114.727 178.866H143.546"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.1772 178.867L53.2245 167.215"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.2857 173.923L54.9816 162.271"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M87.6656 107.544C89.0714 112.134 84.0141 115.107 80.0322 113.737C75.365 112.134 75.1436 105.651 75.1436 105.651"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M83.4486 105.072L83.8 108.25"
        stroke="#031D40"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse cx="122" cy="33.1531" rx="1" ry="1.00465" fill="#152242" />
      <ellipse cx="130" cy="34.158" rx="1" ry="1.00465" fill="#152242" />
    </svg>
  );
};
